import ImageIcon from './imageIcon'
export default ImageIcon
